'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var detect = {};

exports.__exports = detect;
